<template>
  <div>
    <vs-button
      v-if="!active && $store.state.windowWidth < 992"
      color="danger"
      border
      type="gradient"
      @click="active = !active"
      style="bottom: 0px; left: 0px; position:fixed; z-index: 9999; height:60px; width: 100%"
      >Periode aanpassen</vs-button
    >
    <vs-sidebar
      :static-position="$store.state.windowWidth >= 992"
      default-index="1"
      :hidden-background="true"
      color="primary"
      class="sidebarx"
      spacer
      v-model="active"
    >
      <div class="header-sidebar" slot="header">
        <h4>
          Verbruik
        </h4>
      </div>
      <div class="vx-row">
        <div class="vx-col xl:w-full lg:w-1/3">
          <div class="vx-row">
            <div class="vx-col w-full">
              <h4 class="centerx sidebar-item">Periode:</h4>
            </div>
            <div class="vx-col w-full">
              <div class="sidebar-item">
                <flat-pickr
                  class="w-full"
                  :config="configFromdateTimePicker"
                  v-model="fromDate"
                  placeholder="Vanaf"
                />
              </div>
            </div>
            <div class="vx-col w-full">
              <div class="sidebar-item">
                <flat-pickr
                  :config="configTodateTimePicker"
                  v-model="toDate"
                  placeholder="Tot"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="vx-col xl:w-full">
          <h4 class="centerx sidebar-item">Weergave:</h4>
          <ul class="centerx sidebar-item">
            <li class="mb-1">
              <vs-radio v-model="interval" vs-value="Hour">Per Uur</vs-radio>
            </li>
            <li>
              <vs-radio v-model="interval" vs-value="Day">Per Dag</vs-radio>
            </li>
          </ul>
        </div>

        <div class="vx-col xl:w-full">
          <h4 class="centerx sidebar-item">Uitgedrukt in:</h4>

          <ul class="centerx sidebar-item">
            <li class="mb-1">
              <vs-radio v-model="unity" vs-value="Usage"
                >kWh of m<sup>3</sup></vs-radio
              >
            </li>
            <li>
              <vs-radio v-model="unity" vs-value="Money"
                >Euro's
                <a @click="disclaimerActive = true">(Disclaimer)</a></vs-radio
              >
            </li>
          </ul>
        </div>
        <div class="vx-col sm:w-full lg:w-1/3 xl:w-full">
          <ul class="centerx sidebar-item">
            <li class="mb-1">
              <vs-button
                type="border"
                vs-value="Hour"
                class="w-full"
                v-if="getPeriod(-1)[0] >= minMaxDate[0]"
                @click="() => changePeriod(-1)"
                >Vorige periode</vs-button
              >
            </li>
            <li>
              <vs-button
                v-model="interval"
                type="border"
                vs-value="Hour"
                class="w-full"
                v-if="getPeriod(1)[1] <= minMaxDate[1]"
                @click="() => changePeriod(1)"
                >Volgende periode</vs-button
              >
            </li>
          </ul>
        </div>
      </div>
    </vs-sidebar>

    <vs-popup
      class="holamundo"
      title="Disclaimer"
      :active.sync="disclaimerActive"
    >
      <usage-disclaimer />
    </vs-popup>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { mapState } from "vuex";
import UsageDisclaimer from "./UsageDisclaimer";
export default {
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    getPeriod(shift) {
      let periodDuration = moment(this.$store.state.usageSettings.toDate).diff(
        moment(this.$store.state.usageSettings.fromDate)
      );
      periodDuration += 1000 * 60 * 60 * 24 * 1; //add 1 day

      if (shift < 0) {
        return [
          moment(this.fromDate)
            .subtract(periodDuration)
            .format("YYYY-MM-DD"),
          moment(this.toDate)
            .subtract(periodDuration)
            .format("YYYY-MM-DD")
        ];
      } else {
        return [
          moment(this.fromDate)
            .add(periodDuration)
            .format("YYYY-MM-DD"),
          moment(this.toDate)
            .add(periodDuration)
            .format("YYYY-MM-DD")
        ];
      }
    },
    changePeriod(shift) {
      let newPeriod = this.getPeriod(shift);
      this.fromDate = newPeriod[0];
      this.toDate = newPeriod[1];
    }
  },
  components: {
    flatPickr,
    UsageDisclaimer
  },
  computed: {
    ...mapState(["minMaxDate"]),
    fromDate: {
      get() {
        return this.$store.state.usageSettings.fromDate;
      },
      set(value) {
        let val = value ? value : this.minMaxDate[0];
        this.$store.commit("updateFromDate", val);
        this.$store.commit("triggerNewData", "StartDate");
      }
    },
    toDate: {
      get() {
        return this.$store.state.usageSettings.toDate;
      },
      set(value) {
        let val = value ? value : this.minMaxDate[1];
        this.$store.commit("updateToDate", val);
        this.$store.commit("triggerNewData", "EndDate");
      }
    },
    interval: {
      get() {
        return this.$store.state.usageSettings.interval;
      },
      set(value) {
        this.$store.commit("updateInterval", value);
        this.$store.commit("triggerNewData", "Interval");
      }
    },
    unity: {
      get() {
        return this.$store.state.usageSettings.unity;
      },
      set(value) {
        this.$store.commit("updateUnity", value);
        this.$store.commit("triggerNewData", "Unity");
      }
    }
  },
  mounted() {
    this.$set(this.configFromdateTimePicker, "minDate", this.minMaxDate[0]);
    this.$set(this.configFromdateTimePicker, "maxDate", this.minMaxDate[1]);
    this.$set(this.configTodateTimePicker, "minDate", this.minMaxDate[0]);
    this.$set(this.configTodateTimePicker, "maxDate", this.minMaxDate[1]);
  },

  data: () => ({
    active: false,
    disclaimerActive: false,
    configFromdateTimePicker: {
      altInput: true,
      altInputClass: "flatpickr-input",
      altFormat: "d-m-Y"
    },
    configTodateTimePicker: {
      altInputClass: "flatpickr-input",
      altInput: true,
      altFormat: "d-m-Y"
    }
  })
};
</script>

<style lang="scss">
.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}
.flatpickr-calendar {
  z-index: 999999 !important;
}
.flatpickr-input {
  width: 100%;
}

.sidebar-item {
  padding: 10px;
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
@media (min-width: 992px) {
  .sidebarx .vs-sidebar {
    width: 100%;
    max-width: initial;
  }
}
@media (max-width: 992px) {
  .sidebarx {
    z-index: 400002 !important;
    > .vs-sidebar {
      z-index: 400002 !important;
      position: fixed;
    }
  }
}
</style>
